import moment from 'moment';

export const roundTime = (hours) => {
  var whole = Math.floor(hours);
  var parts = hours - whole;

  if (parts >= 0 && parts < 0.125) {
    return '' + whole;
  }
  if (parts >= 0.125 && parts < 0.375) {
    return '' + whole + '¼';
  }
  if (parts >= 0.375 && parts < 0.625) {
    return '' + whole + '½';
  }
  if (parts >= 0.625 && parts < 0.875) {
    return '' + whole + '¾';
  }
  if (parts >= 0.875 && parts < 1.0) {
    return '' + (1 + whole);
  }

  return 'wtf';
};

export const recentFuzzytime = (timestamp) => {
  var minutediff = moment().diff(timestamp, 'minute');
  if (minutediff < 300) {
    return fuzzytime(timestamp);
  }
  return moment(timestamp).format('YYYY-MM-DD HH:mm');
};

export const lateFuzzytime = (timestamp) => {
  var diff = moment().diff(timestamp, 'day');
  if (diff < 1) {
    return { text: 'Expires today', value: '' };
  }
  if (diff <= 14) {
    return { text: '{value} days late', value: diff };
  }
  var weeks = moment().diff(timestamp, 'week');
  return { text: '{value} weeks late', value: weeks };
};

export const fuzzytime = (timestamp) => {
  var minutediff = moment().diff(timestamp, 'minute');

  if (minutediff < 1) {
    return 'A moment ago';
  }
  if (minutediff < 2) {
    return 'A minute ago';
  }
  if (minutediff < 5) {
    return 'Less than 5 minutes ago';
  }
  if (minutediff < 10) {
    return 'Less than 10 minutes ago';
  }
  if (minutediff < 20) {
    return 'About a quarter ago';
  }
  if (minutediff < 35) {
    return 'About half an hour ago';
  }
  if (minutediff < 50) {
    return 'About 45 minutes ago';
  }
  if (minutediff < 75) {
    return 'About an hour ago';
  }
  if (minutediff < 100) {
    return 'About an hour and a half ago';
  }
  if (minutediff < 100) {
    return 'About an hour and a half ago';
  }
  if (minutediff < 130) {
    return 'About two hours ago';
  }
  if (minutediff < 300) {
    return 'A few hours ago';
  }
  if (minutediff < 630) {
    return '5 to 10 hours ago';
  }
  if (minutediff < 1200) {
    return 'Almost a day ago';
  }
  if (minutediff < 2160) {
    return 'About a day ago';
  }
  if (minutediff < 3600) {
    return 'About two days ago';
  }
  if (minutediff < 10080) {
    return 'Less than a week ago';
  }
  if (minutediff < 20160) {
    return 'Less than two weeks ago';
  }
  if (minutediff < 43200) {
    return 'Less than a month ago';
  }

  return 'More than a month ago';
};



// WEBPACK FOOTER //
// ./src/common/timeHelpers.js